(() => {
  const observers = new WeakMap();
  function initialize(scope = document) {
    const roots = scope.matches?.('[data-everydae-sale]') ? [scope] : scope.querySelectorAll('[data-everydae-sale]');
    roots.forEach((root) => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const hero = root.querySelector('.ed-hero');
      const signup = root.querySelector('.ed-signup');
      const sticky = root.querySelector('[data-sale-sticky]');
      const email = signup.querySelector('input[type="email"]');
      const observer = new IntersectionObserver(([entry]) => {
        sticky.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0;
      }, { threshold: 0 });
      observer.observe(hero);
      observers.set(root, observer);
      root.addEventListener('click', (event) => {
        const anchor = event.target.closest('a[href="#early-access"]');
        if (anchor) {
          event.preventDefault();
          signup.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
          email.focus({ preventScroll: true });
        }
        if (event.target.closest('[data-signup-preview]')) email.focus({ preventScroll: true });
      });
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-everydae-sale]').forEach((root) => observers.get(root)?.disconnect());
  });
})();
